import { mediaAppMobile } from 'styles/grid';

export const getCssByAppBreakpoint = (
  attribute: string,
  valueConfig: string | number | { desktop?: any; mobile?: any },
  convertValue = (value): string => value,
): string => {
  if (typeof valueConfig === 'object') {
    const CSSValue = [];

    if (valueConfig.desktop) {
      CSSValue.push(`${attribute}: ${convertValue(valueConfig.desktop)};`);
    }

    if (valueConfig.mobile) {
      CSSValue.push(`
        ${mediaAppMobile} {
          ${attribute}: ${convertValue(valueConfig.mobile)};
        }
      `);
    }

    return CSSValue.join('\n');
  }

  return `${attribute}: ${convertValue(valueConfig)};`;
};
